export const viewModelHotelOwnerZinantisData = {
    ZinantisMembership: true,
    Agencies: {
        Id: true,
        IdAgency: true,
        DateCreated: true,
        AllHotels: true,
        ZinantisRelationships: {
            Id: true,
            IdHotel: true,
            ZinantisRelationshipStatusType: {
                Key: true,
                Caption: true,
                Name: true,
                LocalizedCaption: true,
                Color: true,
            },
        },
        IdZinantisRelationshipStatusType: true,
        ZinantisRelationshipStatusType: {
            Key: true,
            Caption: true,
            LocalizedCaption: true,
            Name: true,
            Color: true,
        },
        ZinantisConnectionRequests: {
            RequestedBy: true,
            DateCreated: true,
            RequestDate: true,
            ResolutionDate: true,
            ZinantisConnectionRequestStatus: {
                ZinantisConnectionRequestStatusType: {
                    Key: true,
                    Caption: true,
                    LocalizedCaption: true,
                    Name: true,
                },
            },
        },
    },
    SupplierHotels: {
        Id: true,
        Name: true,
        IdHotel: true,
        Hotel: {
            Name: true,
            City: {
                Name: true,
            },
        },
        Descriptions: {
            Description: true,
            ContentLanguage: {
                Key: true,
                Caption: true,
                LocalizedCaption: true,
                Name: true,
            },
        },
    },
};
